module.exports = __webpack_public_path__ + "static/media/taboola-booth.530245ac.jpg";